import React from 'react';
import styled from 'styled-components';
import { Palette } from '../../components/utils';

// Shared drawer for chat screens.
const ChatDrawer = ({ ariaLabel, onClose, children }) => (
  <>
    <Backdrop onClick={onClose} aria-hidden="true" />
    <Panel role="dialog" aria-label={ariaLabel}>
      {children}
    </Panel>
  </>
);

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: ${Palette.TRANS_GREY_BG};
  z-index: 1040;
`;

const Panel = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  width: min(550px, 100vw);
  height: 100vh;
  background: ${Palette.WHITE};
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

export default ChatDrawer;
